// General Navbar configuration.
export function getNavbarZIndex() { return 1899; }

// Desktop navbar configuration.
export function getNavbarDesktopBreakpoint() { return 900; }
export function getDesktopNavbarTopBarHeightPx() { return 55; }
export function getDesktopNavbarBotBarHeightPx() { return 55; }

export function getNavbarDesktopConditionMediaQuery() {
  // We will only show the desktop navbar if:
  //  1) There is at least a fine pointing device (because this navbar needs the concept of hovering).
  //  2) The screen is sufficiently large.
  return `(min-width: ${getNavbarDesktopBreakpoint()}px) and (any-pointer: fine)`;
}

// Mobile navbar configuration.
export function getMobileNavbarHeightPx() { return 80; }

export function getMobileNavbar2HeightPx() { return 90; }

export function getDesktopNavbarHeightPx() {
  return getDesktopNavbarTopBarHeightPx() + getDesktopNavbarBotBarHeightPx();
}

export function getNavbarHeightPx() {
  const desktop = window.matchMedia(getNavbarDesktopConditionMediaQuery()).matches;
  if (desktop) return getDesktopNavbarHeightPx();
  return getMobileNavbarHeightPx();
}
